import React, { Component } from 'react';
import pageStyle from './page.layout.less';
import style from './finish.page.layout.less';
import className from 'classnames';
import { fromJS } from 'immutable';
import iconsStyle from '../styles/icons.less';
import * as ld from 'lodash';
import jQuery from 'jquery';
import _ from '../i18n.jsx';
import { EMPTY_STRING, EMPTY_OBJECT } from '../questionnaire.utils.jsx';

const UNKNOWN = 'UNKNOWN';
export default class FinishPage extends Component {
    constructor() {
        super();
        this.getNumberOfAnswers = this.getNumberOfAnswers.bind(this);
        this.getSpentTime = this.getSpentTime.bind(this);
    }
    static countAnswers(fields, fieldsMap) {
        let passedAnswers = 0,
            unknownAnswers = 0;
        const _fields = fromJS(fields);
        ld.forEach(fieldsMap, (item) => {
            const itemValue = _fields.getIn(item.split(' '));
            switch (typeof itemValue) {
                case 'string':
                    if (itemValue === UNKNOWN) {
                        unknownAnswers++;
                    } else if (itemValue !== EMPTY_STRING) {
                        passedAnswers++;
                    }
                    break;
                case 'undefined':
                    break;
                case 'object':
                    if (itemValue.size) { passedAnswers++; }
                    break;
                default:
                    break;
            }
        });
        return { passedAnswers, unknownAnswers };
    }
    getNumberOfAnswers() {
        const { fields, fieldsMap } = this.props;
        const { passedAnswers, unknownAnswers } = FinishPage.countAnswers(fields, fieldsMap);
        const answeredQuestions = passedAnswers + unknownAnswers;
        const skippedAnswers = fieldsMap.length - answeredQuestions;
        return { answered: passedAnswers, unknown: unknownAnswers, skipped: skippedAnswers };
    }
    getSpentTime() {
      const timeSpent = this.props.fields.timeSpent;
      return Math.floor(timeSpent / 60);
    }
    render() {
        const { answered, unknown, skipped } = this.getNumberOfAnswers();
        const spentTime = this.getSpentTime();
        const { height, token, pageList, language, fields, pedigreeGenerated } = this.props;
        const { finished, pages } = fields;
        const finishPageStyle = { minHeight: height };
        return (
            <section className={pageStyle.page} style={finishPageStyle}>
                <div className={pageStyle.page__wrapper}>
                    <div className={style.headerWrapper}>
                        <QuestionsStats answered={answered} unknown={unknown} skipped={skipped}/>
                        <SpentTimeStats spentTime={spentTime}/>
                    </div>
                    <QuestionnairePreview pageList={pageList} pages={pages} finished={finished} pedigreeGenerated={pedigreeGenerated} token={token} />
                    <QuestionnaireFooter token={token} language={language}/>
                </div>
            </section>
        );
    }
}

export class QuestionnaireFooter extends Component {
    constructor() {
        super();
        this.exportToPDF = this.exportToPDF.bind(this);
    }
    exportToPDF() {
        const { language, token } = this.props;
        const locale = language.get('code');
        window.open(`/pq/${locale}/${token}/pdf/?readonly=1`);
    }
    render() {
        const strings = FinishPage.STRING;
        return (<div className={style.footerWrapper}>
                    <FinishPageHeadline headLine={strings.actions} />
                    <div>
                        <a onClick={this.exportToPDF}><i className={className(style.footerIcon, iconsStyle[`icon-action-print`])}></i>{strings.exportToPDF}</a>
                    </div>
                </div>);
    }
}

export class QuestionnairePreview extends Component {
    constructor() {
        super();
        this.setPedigreePreviewStyle = this.setPedigreePreviewStyle.bind(this);
    }
    setPedigreePreviewStyle() {
        const { finished, token } = this.props;
        if (!finished) { return EMPTY_OBJECT; }
        const URL = `/api2/question/${token}/svg/`;
        jQuery.get(URL);
        return {
            backgroundImage: `url(${URL})`,
            backgroundSize: 'contain',
            WebkitBackgroundSize: 'contain',
            MozBackgroundSize: 'contain',
            OBackgroundSize: 'contain'
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.pedigreeGenerated !== this.props.pedigreeGenerated;
    }
    render() {
        const strings = FinishPage.STRING;
        const pedigreePreviewStyle = this.setPedigreePreviewStyle();
        return (
            <div className={style.diagramPreviewWrapper}>
                <div className={style.diagramPreview}>
                    <FinishPageHeadline headLine={strings.familyDiagram} />
                    <FinishPageDiagramHelp />
                    <div className={style.diagram} style={pedigreePreviewStyle}></div>
                </div>
            </div>
        );
    }
}

export class FinishPageDiagramHelp extends Component {
    render() {
        const strings = FinishPage.STRING;
        return (
            <div className={style.diagramHelp}>
                <table>
                    <tbody>
                        <tr>
                            <td className={iconsStyle[`diag-icon-male`]}></td>
                            <td>{strings.male}</td>
                        </tr>
                        <tr>
                            <td className={iconsStyle[`diag-icon-female`]}></td>
                            <td>{strings.female}</td>
                        </tr>
                        <tr>
                            <td className={iconsStyle[`diag-icon-iunknown`]}></td>
                            <td>{strings.unknown}</td>
                        </tr>
                        <tr>
                            <td className={iconsStyle[`diag-icon-deceased`]}></td>
                            <td>{strings.deceased}</td>
                        </tr>
                        <tr>
                            <td className={iconsStyle[`diag-icon-you`]}></td>
                            <td>{strings.thisIsYou}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export class QuestionsStats extends Component {
    render() {
        const { answered, unknown, skipped } = this.props;
        const strings = FinishPage.STRING;
        return (<div className={style.questionsWrapper}>
                    <FinishPageHeadline headLine={strings.questions} />
                    <div className={style.questions}>
                        <FinishPageTotal answered={true} total={answered} />
                        <FinishPageTotalDescription answered={true} description={strings.answered}/>
                    </div>
                    <div className={style.questions}>
                        <FinishPageTotal skipped={true} total={skipped} />
                        <FinishPageTotalDescription skipped={true} description={strings.skipped}/>
                    </div>
                    <div className={style.questions}>
                        <FinishPageTotal total={unknown} />
                        <FinishPageTotalDescription description={strings.didntKnow}/>
                    </div>
                </div>);
    }
}

export class SpentTimeStats extends Component {
    render() {
        const spentTime = this.props.spentTime;
        const strings = FinishPage.STRING;
        return (<div className={style.spentTimeWrapper}>
                    <div className={style.spentTime}>
                        <FinishPageHeadline headLine={strings.spent} />
                        <FinishPageTotal total={spentTime} />
                        <FinishPageTotalDescription description={strings.minutes}/>
                    </div>
                </div>);
    }
}

export class FinishPageTotalDescription extends Component {
    render() {
        const { description, answered, skipped } = this.props;
        const descriptionClassName = className(style.totalDescription, { [style.answered]: answered }, { [style.skipped]: skipped });
        return <span className={descriptionClassName}>{description}</span>;
    }
}

export class FinishPageTotal extends Component {
    render() {
        const { total, answered, skipped } = this.props;
        const totalValueClassName = className(style.total, { [style.answered]: answered }, { [style.skipped]: skipped });
        return <span className={totalValueClassName}>{total}</span>;
    }
}

export class FinishPageHeadline extends Component {
    render() {
        return <span className={style.headline}>{this.props.headLine}</span>;
    }
}

FinishPage.STRING = {
    male          : _('Male'),
    female        : _('Female'),
    familyDiagram : _('Family diagram'),
    actions       : _('Actions'),
    unknown       : _('Unknown'),
    deceased      : _('Deceased'),
    questions     : _('Questions'),
    answered      : _('Answered'),
    skipped       : _('Skipped'),
    spent         : _('Spent'),
    minutes       : _('minutes'),
    thisIsYou     : _('This is you'),
    didntKnow     : _(`Didn't KNOW`),
    exportToPDF   : _('Export to PDF')
};
